import { useEffect, useRef, useState } from 'react';
import { api } from '../../lib/api';
import { type TranscriptMsg } from '../../lib/n4';
import { MessageList } from './MessageList';

// Olvasható beszélgetés a CLI átiratából: 3 másodpercenként frissül, alulra görget.
export function ReadableView({ projectId, cliSessionId, live = true }: { projectId: number; cliSessionId: string | null; live?: boolean }) {
  const [msgs, setMsgs] = useState<TranscriptMsg[]>([]);
  const [found, setFound] = useState(true);
  const bottom = useRef<HTMLDivElement>(null);
  const count = useRef(0);
  useEffect(() => {
    if (!cliSessionId) return undefined;
    let stop = false;
    const load = () => api<{ messages: TranscriptMsg[]; found: boolean }>(`/api/n4/projects/${projectId}/transcript?session=${cliSessionId}`)
      .then((r) => { if (stop) return; setFound(r.found); setMsgs(r.messages); if (r.messages.length !== count.current) { count.current = r.messages.length; setTimeout(() => bottom.current?.scrollIntoView({ block: 'end' }), 50); } })
      .catch(() => {});
    void load();
    const t = setInterval(load, 3000);
    return () => { stop = true; clearInterval(t); };
  }, [projectId, cliSessionId]);
  if (!cliSessionId) return <p className="p-4 text-sm text-neutral-500">Még nincs beszélgetés ehhez a projekthez. Nyiss ablakot a „Terminál” fülön.</p>;
  if (!found) return <p className="p-4 text-sm text-neutral-500">Az átirat még nem jött létre (az első üzenet után jelenik meg).</p>;
  return (
    <div className="h-full overflow-auto p-3">
      {!live && <p className="mb-2 text-[11px] text-amber-300/80">Nincs élő ablak — az utolsó beszélgetés átirata. A „Terminál” fülön folytatható.</p>}
      <p className="mb-3 text-[11px] text-neutral-600">Csak a te üzeneteid és az ügynök válaszai. A rendszer üzenetei (munkás-jelentés, szabály-változás) halványan; az eszközhívások rejtve, számmal.</p>
      <MessageList msgs={msgs} />
      {msgs.length === 0 && <p className="text-sm text-neutral-500">Még nincs üzenet.</p>}
      <div ref={bottom} />
    </div>
  );
}
